import { useContext, useEffect, useState } from "react";
import { IRegistrationCredentialsFormValues } from "../../../authentication/_interfaces/IRegistrationCredentialsFormValues";
import { Organization, RootContext } from "../../../../stores";
import { IAdminInvitationFlowValues } from "../_interfaces/IAdminInvitationFlowValues";
import { AppError } from "../../../../stores/models/errors/AppError";
import { ITermsOfServiceFormValues } from "../../../authentication/_interfaces/ITermsOfServiceFormValues";
import { TermsOfServiceStepValues } from "../_interfaces/IAdminInvitationStepTypeValues";
import { UserProfileTypes } from "../../../../data/UserProfileTypes";

export function useTermsOfServiceController(
    values: TermsOfServiceStepValues,
    allValues: IAdminInvitationFlowValues,
    update: (patch: Partial<ITermsOfServiceFormValues>) => void,
    onSuccess: (override?: Partial<ITermsOfServiceFormValues>) => void
) {
    const rootStore = useContext(RootContext);

    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof IRegistrationCredentialsFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    useEffect(() => {
        if (validationRun) {
            setFieldErrors({
                termsOfServiceAccepted: !values.termsOfServiceAccepted ? 'Please review and accept the Terms of Service to continue.' : undefined
            });
        }
    }, [values.termsOfServiceAccepted, validationRun])

    const setOrganizationProfileAsActiveProfile = async () => {
        const organizationProfile = rootStore.userStore.user.profileData?.find(profile => (profile.type === UserProfileTypes.Nonprofit || profile.type === UserProfileTypes.ForProfit) && (profile.identity as Organization).name === allValues.organizationName);
        if (organizationProfile) {
            await rootStore.userStore.updateUserProfileStatus(rootStore.userStore.user.id, organizationProfile.id, 'active');
        }
    }

    const submit = async (override?: Partial<IRegistrationCredentialsFormValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            if (allValues.userId !== undefined && allValues.userId > 0 && values.termsOfServiceAccepted) { // If valid submission:
                const result = await rootStore.invitationStore.acceptAdminInvite(allValues.token, values.termsOfServiceAccepted);
                await setOrganizationProfileAsActiveProfile();
                const updatedOverride = { ...override, invitationAccepted: true };
                update(updatedOverride);
                onSuccess(updatedOverride);
            }
        } catch (err) {
            if (err instanceof AppError) {
                setError(err.message);
            } else {
                setError("An unknown error occurred.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values: { ...values, buttonText: "Accept Invitation" },
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}
